import InvalidAccount from "modules/invalid-account/components/InvalidAccount";
import { LoggedIn } from "modules/shared/auth";

module.exports = {
  path: "invalid-account",
  component: LoggedIn(InvalidAccount),
  childRoutes: [],
};
